<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-4">
                        <az-input 
                            type="button-group"
                            :optionsList="[
                                { id: 'N', search: 'Não Realizadas' },
                                { id: 'R', search: 'Realizadas' },
                                { id: 'T', search: 'Todas' },
                            ]"
                            optionsData="id"
                            v-model="filtro.tipo" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input 
                            type="checkbox-group"
                            label="Minhas"
                            v-model="filtro.minhas" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load(false)" v-if="filtro.tipo != 'N'" />

                        <az-submit @click="load(false)" color="outline-primary" :hide_content_while_loading="true" v-else>
                            <i class="fas fa-sync-alt fa-fw"></i>
                        </az-submit>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="usuarios.index" 
                            optionsName="filtro-usuarios"
                            :optionsParm="{ where: { fl_ativo: true } }"
                            :optionsSync="false"
                            :edicao="!filtro.minhas"
                            v-model="filtro.usuario" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            icon="fa-solid fa-arrow-right fa-fw"
                            placeholder="Todos os Recursos..."
                            type="autocomplete" 
                            optionsMode="aql"
                            :optionsParm="{ ativos: 1 }"
                            service="equipamentos.index"
                            optionsDisplay="search"
                            optionsData="id_equipamento"
                            ref="info_eqp_busca"
                            v-model="filtro.id_equipamento" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input 
                            icon="fa-solid fa-filter fa-fw"
                            type="select" 
                            :validate="validate"
                            :optionsList="lista_status" 
                            optionsData="id_contato_status"
                            placeholder="Todos os status..."
                            v-model="filtro.id_contato_status" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input   
                            icon="fa fa-search fa-fw"
                            v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2" title="Quantidade">{{ lista.length }}</span>
                                    <button type="button" class="btn btn-outline-primary" @click="incluir()">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>

                                    <print-export printid="impressao" :left="true" :dados="dados_exportacao" />
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2" v-if="lista_grupos_atend && lista_grupos_atend.length">
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-building fa-fw"
                            type="select"
                            placeholder="Todas as Unidades..."
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtro.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-filter-circle-dollar"
                            type="select"
                            placeholder="Centro de Custo..."
                            :optionsList="$util.centros_usuario(filtro.id_unidade_operacao, true)"
                            optionsData="id_centro_custo"
                            :edicao="( filtro.id_unidade_operacao && !isNaN(filtro.id_unidade_operacao) ) ? true : false"
                            v-model="filtro.id_centro_custo" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa-solid fa-screwdriver-wrench fa-fw"
                            placeholder="Todos os Grupos..."
                            type="select"
                            :optionsList="lista_grupos_atend"
                            v-model="filtro.grupo" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            placeholder="Selecione o Serviço..."
                            icon="fa-solid fa-hammer fa-fw"
                            type="select"
                            :edicao="filtro.grupo ? true : false"
                            :optionsList="filtro.grupo ? filtro.grupo.servicos : []"
                            optionsData="id_tarefa_grupo_servico"
                            v-model="filtro.id_tarefa_grupo_servico" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>    

        <az-empty-state v-if="!lista || !lista.length" msg="Nenhuma tarefa identificada." icon="fas fa-tasks" />

        <div class="mb-3 mx-3" v-else>

            <div id="impressao">

                <cabecalho-generico titulo="Tarefas" />

                <div class="row my-2 py-2 dashcard w3-animate-opacity bg-white" v-for="(tarefa, itx) in lista" :key="itx">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="checkbox"
                            :edicao="tarefa.pode_executar"
                            v-model="tarefa.fl_feita" 
                            @click="atualizar_execucao(tarefa)" >
                            <template v-slot:button-pre>
                                <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="editar(tarefa)">
                                    <i class="fas fa-edit"></i>
                                </button>

                                <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="abrir_contatos(tarefa)">
                                    <i class="fa fa-comments" aria-hidden="true"></i>
                                </button>

                                <button type="button" class="btn btn-sm btn-outline-primary" 
                                    @click="$refs.anexo.abrir_anexar_arquivo(tarefa)">
                                    <i class="fa fa-paperclip" aria-hidden="true"></i>
                                </button>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-8" :class="tarefa.para_paciente ? 'col-md-4' : ''">
                        <div class="badge badge-primary mr-1" v-if="tarefa.servico">
                            {{ tarefa.servico.grupo.st_sigla ? tarefa.servico.grupo.st_sigla : tarefa.servico.grupo.st_nome }}
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            {{ tarefa.servico.st_sigla ? tarefa.servico.st_sigla : tarefa.servico.st_nome }}
                        </div>
                        <div class="badge badge-secondary" v-if="tarefa.para_outro && tarefa.usuario">
                            {{ tarefa.usuario.pessoa ? tarefa.usuario.pessoa.st_nome : tarefa.usuario.st_login }}
                        </div>
                        <div class="badge badge-secondary" v-else-if="!tarefa.para_outro && tarefa.usuario && tarefa.id_tarefa_grupo_servico">
                            Para mim
                        </div>
                        <div class="badge badge-warning" v-else-if="!tarefa.id_usuario && tarefa.id_tarefa_grupo_servico">
                            Não atribuída
                        </div>
                        <div>
                            <div v-if="tarefa.contato && tarefa.contato.contato_status">
                                <span class="badge" :class="'badge-' + tarefa.contato.contato_status.st_color">
                                    {{ tarefa.contato.contato_status.st_contato_status }}
                                </span>
                            </div>
                            {{ tarefa.st_descricao }}
                        </div>
                        <div class="small text-muted" v-if="tarefa.id_usuario_criador != $store.state.user.id_usuario">
                            Criada por {{ tarefa.criador.pessoa ? tarefa.criador.pessoa.st_nome : tarefa.criador.st_login }}
                        </div>
                    </div>
                    <div class="col col-12 col-md-4" v-if="tarefa.para_paciente">
                        <celula-dados-paciente :hor="{ marcacao: tarefa }">
                            <template v-slot:plano v-if="tarefa.laudo">
                                <div>
                                    <span class="small" v-if="tarefa.laudo.atendimento_procedimento && tarefa.laudo.atendimento_procedimento.procedimento">
                                        <a href="#" @click.prevent="visualizar_laudo(tarefa.laudo)" class="card-link" v-if="tarefa.id_usuario == $store.state.user.id_usuario">
                                            {{ tarefa.laudo.atendimento_procedimento.procedimento.search }}
                                        </a>
                                        <span v-else>
                                            {{ tarefa.laudo.atendimento_procedimento.procedimento.search }}
                                        </span>
                                    </span>
                                    <span class="badge ml-2" :class="'badge-' + tarefa.laudo.status_laudo.st_color" title="Status" v-if="tarefa.laudo.status_laudo">
                                        {{ tarefa.laudo.status_laudo.search }}
                                    </span>
                                </div>
                            </template>
                        </celula-dados-paciente>
                    </div>
                    <div class="col col-12 col-md-2">
                        <div>
                            #{{ tarefa.id_tarefa }}
                            <span class="badge badge-light ml-2" v-if="tarefa.centro && tarefa.centro.unidade_operacao.st_sigla">
                                {{ tarefa.centro.unidade_operacao.st_sigla }}
                            </span>
                        </div>

                        <div v-if="tarefa.tarefa_prioridade" class=" text-nowrap text-truncate">
                            <i :class="'fa-solid fa-bell fa-fw mr-1 text-' + tarefa.tarefa_prioridade.st_cor"></i>
                            <span class="small">
                                {{ tarefa.tarefa_prioridade.st_prioridade }}
                            </span>
                        </div>

                        <div v-if="tarefa.centro" class=" text-nowrap text-truncate">
                            <i class="fa-solid fa-filter-circle-dollar fa-fw mr-1"></i>
                            <span class="small">
                                {{ tarefa.centro.st_nome }}
                            </span>
                        </div>

                        <div class=" text-nowrap text-truncate">
                            <i class="fa fa-calendar-plus-o fa-fw mr-1" aria-hidden="true"></i>
                            {{ $util.getFormatDate(tarefa.created_at) }}
                        </div>

                        <div v-if="tarefa.dt_prazo">
                            <i class="fa-solid fa-hourglass-end fa-fw mr-1"></i>
                            <span class="badge ml-1" :class="'badge-' + tarefa.cor_prazo" title="Prazo">
                                {{ $util.getFormatDate(tarefa.dt_prazo) }}
                            </span>
                        </div>

                        <div v-if="tarefa.dt_execucao && tarefa.fl_feita" class=" text-nowrap text-truncate">
                            <i class="fa fa-calendar-check-o fa-fw mr-1"></i>
                            {{ $util.getFormatDate(tarefa.dt_execucao) }}
                        </div>

                        <div v-if="tarefa.equipamento">
                            <i class="fa-solid fa-arrow-right fa-fw mr-1"></i>
                            {{ tarefa.equipamento.search }}
                        </div>

                        <div v-if="tarefa.id_usuario_criador == $store.state.user.id_usuario && tarefa.fl_feita" class=" text-nowrap text-truncate">
                            <a href="#" @click.prevent class="card-link">
                                <template v-if="tarefa.in_nps_score === null">
                                    <i class="fa-regular fa-star-sharp fa-fw mr-1"></i>
                                    Avaliar
                                </template>
                                <template v-else>
                                    <i class="fa-solid fa-star-sharp fa-fw mr-1"></i>
                                    {{ tarefa.in_nps_score }}
                                </template>
                            </a>
                        </div>
                    </div>
                </div>

            </div>

            <br><br><br><br><br>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="tarefaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ edicao.id_tarefa ? '' : 'Nova' }}
                            Tarefa
                            <span class="badge badge-secondary ml-2" v-if="edicao.id_tarefa">
                                #{{ edicao.id_tarefa }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col">
                                <az-input
                                    label="Descrição"
                                    type="textarea"
                                    rows="3"
                                    required
                                    :validate="validate"
                                    :edicao="!edicao.fl_feita"
                                    v-model="edicao.st_descricao" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Prazo"
                                    type="date"
                                    :validate="validate"
                                    :edicao="!edicao.fl_feita && !( edicao.tarefa_prioridade && edicao.tarefa_prioridade.in_sla_solucao )"
                                    v-model="edicao.dt_prazo" />
                            </div>
                            <div class="col col-12 col-md-6" v-if="prioridades && prioridades.length">
                                <az-input
                                        sizing="sm"
                                        label="Prioridade da Tarefa"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="prioridades"
                                        optionsData="id_prioridade"
                                        optionsDisplay="st_prioridade"
                                        :edicao="!edicao.fl_feita"
                                        :validate="validate"
                                        v-model="edicao.id_tarefa_prioridade" />
                            </div>
                        </div>

                        <template v-if="!edicao.id_tarefa && $store.state.unidade.unidade_operacaos.length > 1">
                            <div class="form-row">
                                <div class="col col-12 col-md-6" v-if="$store.state.unidade.unidade_operacaos.length > 1">
                                    <az-input
                                        sizing="sm"
                                        label="Unidade"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="$util.unidades_com_tags(false, true)"
                                        :validate="validate"
                                        optionsData="id_unidade_operacao"
                                        v-model="edicao.id_unidade_operacao" />
                                </div>
                                <div class="col col-12 col-md-6" v-if="edicao.id_unidade_operacao">
                                    <az-input
                                        sizing="sm"
                                        label="Centro de Custo"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="$util.centros_usuario(edicao.id_unidade_operacao, true)"
                                        optionsData="id_centro_custo"
                                        required
                                        :validate="validate"
                                        v-model="edicao.id_centro_custo" />
                                </div>
                            </div>
                        </template>

                        <template v-else-if="edicao.id_centro_custo">
                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Unidade"
                                        :edicao="false"
                                        v-model="edicao.centro.unidade_operacao.st_nome" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Centro de Custo"
                                        :edicao="false"
                                        v-model="edicao.centro.st_nome" />
                                </div>
                            </div>
                        </template>

                        <!-- Lista de Grupos / Serviços -->

                        <div class="my-3" v-if="lista_tarefa_grupos && lista_tarefa_grupos.length">

                            <div class="row" v-if="( !edicao.id_tarefa )">
                                <div class="col col-12">
                                    <az-input
                                        type="button-group"
                                        :optionsList="[
                                            { id: 'M', search: 'Para mim' },
                                            { id: 'O', search: 'Para outra pessoa' },
                                            { id: 'G', search: 'Para um grupo de atendimento' } 
                                        ]" 
                                        optionsDisplay="search"
                                        optionsData="id"
                                        v-model="edicao.destino" />
                                </div>
                            </div>

                            <!-- Tarefa Registrada para um Grupo -->

                            <div class="form-row" v-if="edicao.destino == 'G' && edicao.id_tarefa && edicao.servico">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Grupo"
                                        :edicao="false"
                                        v-model="edicao.servico.grupo.st_nome" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        v-if="( filtro.grupo )"
                                        label="Serviço"
                                        type="select"
                                        placeholder="Selecione o serviço..."
                                        :optionsList="lista_servicos(edicao.servico.grupo.id_tarefa_grupo)"
                                        optionsData="id_tarefa_grupo_servico"
                                        required
                                        :validate="validate"
                                        v-model="edicao.id_tarefa_grupo_servico" />

                                    <az-input
                                        v-else
                                        label="Serviço"
                                        :edicao="false"
                                        v-model="edicao.servico.st_nome" />
                                </div>
                            </div>

                            <!-- Nova Tarefa para um Grupo -->

                            <div class="form-row" v-else-if="edicao.destino == 'G'">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Grupo"
                                        placeholder="Selecione o grupo..."
                                        type="select"
                                        :optionsList="lista_tarefa_grupos"
                                        required
                                        :validate="validate"
                                        v-model="edicao.grupo" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Serviço"
                                        type="select"
                                        placeholder="Selecione o serviço..."
                                        :optionsList="edicao.grupo ? edicao.grupo.servicos : []"
                                        optionsData="id_tarefa_grupo_servico"
                                        required
                                        :validate="validate"
                                        :edicao="edicao.grupo ? true : false"
                                        v-model="edicao.id_tarefa_grupo_servico"
                                        @input="selecao_formulario()" />
                                </div>
                            </div>

                            <div class="row" v-else-if="edicao.destino == 'O'">
                                <div class="col">
                                    <az-input
                                        label="Atribuída Para"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="usuarios.index" 
                                        optionsName="filtro-usuarios"
                                        :optionsParm="{ where: { fl_ativo: true } }"
                                        :optionsSync="false"
                                        required 
                                        :validate="validate"
                                        v-model="edicao.usuario" />
                                </div>
                            </div>

                        </div>

                        <!-- Sem Lista de Grupos -->

                        <template v-if="!( lista_tarefa_grupos && lista_tarefa_grupos.length ) || ( edicao.pode_executar ) || ( edicao.destino == 'G' )">

                            <div class="row mt-3">
                                <div class="col">
                                    <div class="card">
                                        <div class="card-body d-flex">
                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input" 
                                                    id="para_outro" 
                                                    :disabled="edicao.fl_feita"
                                                    v-model="edicao.para_outro">
                                                <label class="custom-control-label" for="para_outro"></label>
                                            </div>
                                            <div class="ml-2">
                                                Atribuir a outra pessoa
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3" v-if="edicao.para_outro || edicao.destino == 'O'">
                                <div class="col">
                                    <az-input
                                        label="Atribuída Para"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="usuarios.index" 
                                        optionsName="filtro-usuarios"
                                        :optionsParm="{ where: { fl_ativo: true } }"
                                        :optionsSync="false"
                                        required 
                                        :edicao="!edicao.fl_feita"
                                        :validate="validate"
                                        v-model="edicao.usuario" />
                                </div>
                            </div>

                        </template>

                        <div class="row">
                            <div class="col">
                                <div class="card">
                                    <div class="card-body d-flex">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" 
                                                id="para_paciente" 
                                                :disabled="edicao.fl_feita"
                                                v-model="edicao.para_paciente">
                                            <label class="custom-control-label" for="para_paciente"></label>
                                        </div>
                                        <div class="ml-2">
                                            Tarefa relacionada a paciente
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="edicao.para_paciente">
                            <div class="col col-12">
                                <az-input 
                                    label="Paciente"
                                    placeholder="Informe o nome ou CPF do paciente..."
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="pacientes.index"
                                    optionsDisplay="search"
                                    ref="info_paciente"
                                    required
                                    :edicao="!edicao.fl_feita"
                                    :validate="validate"
                                    v-model="edicao.paciente" 
                                    :optimized_ac="true">
                                    <template v-if="edicao.paciente" v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-outline-primary" @click="abrir_pep(edicao.paciente)">
                                                <i class="fas fa-id-badge"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="card">
                                    <div class="card-body d-flex">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" 
                                                id="para_eqp" 
                                                :disabled="edicao.fl_feita"
                                                v-model="edicao.para_eqp">
                                            <label class="custom-control-label" for="para_eqp"></label>
                                        </div>
                                        <div class="ml-2">
                                            Tarefa relacionada a recurso
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="edicao.para_eqp">
                            <div class="col col-12">
                                <az-input 
                                    label="Recurso"
                                    placeholder="Informe o recurso associado..."
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    :optionsParm="{ ativos: 1, id_unidade_operacao: edicao.id_unidade_operacao }"
                                    service="equipamentos.index"
                                    optionsDisplay="search"
                                    ref="info_eqp"
                                    required
                                    :edicao="!edicao.fl_feita"
                                    :validate="validate"
                                    v-model="edicao.equipamento" />
                            </div>
                        </div>

                        <!-- Formulário do Serviço -->
                        <template v-if="edicao.id_tarefa_grupo_servico && edicao.js_outros_campos && edicao.js_outros_campos.length">
                            <az-sub-title title="Informações Adicionais"></az-sub-title>
                            <div class="row">
                                <div class="col">
                                    <formulario 
                                        :validate="validate"
                                        :compact="true"
                                        tamanhoform="P"
                                        v-model="edicao.js_outros_campos" 
                                        :mode="edicao.id_tarefa ? 'view' : 'fixed'"
                                        :config="true" />
                                </div>
                            </div>
                        </template>

                        <template v-if="edicao.created_at && edicao.criador && edicao.criador.pessoa">
                            <hr>
                            <div class="small">Criada por {{ edicao.criador.pessoa.st_nome }} em {{ $util.getFormatDate(edicao.created_at) }} {{ edicao.created_at.substr(11,5) }}</div>
                        </template>

                        <br><br><br><br><br><br><br><br><br>

                        <pre v-if="false">{{ edicao }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="tarefa" :id="edicao.id_tarefa" />
                        <az-submit @click="remover()" v-if="edicao.id_tarefa && !edicao.fl_feita" color="danger">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()" v-if="!edicao.fl_feita">{{ edicao.id_tarefa ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <registrar-contatos ref="regcontatos" @refresh="loadContato" titulo="Informação">
            <template v-slot:info>
                <p class="alert alert-secondary" v-if="edicao">
                    {{ edicao.st_descricao }}
                </p>
            </template>
        </registrar-contatos>

        <anexar-marcacao-documentos
            model="tarefa"
            campo_id="id_tarefa"
            ref="anexo" />

        <nav class="navbar fixed-bottom navbar-light bg-light">
            <a href="#" @click.prevent="$router.go(-1)" class="btn btn-secondary">Voltar</a>
        </nav>

        <pre v-if="false">{{ lista_tarefa_grupos }}</pre>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import AzAuditLogButton from'../../util/AzAuditLogButton.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import AnexarMarcacaoDocumentos from '../../modulos/recepcao/AnexarMarcacaoDocumentos.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data() { 
        return { 
            filtro: { 
                tipo: "N", 
                minhas: true, 
                inicio: "",
                fim: "",
                periodo: "m", 
                search: "", 
                grupo: "",
                id_tarefa_grupo_servico: "", 
                id_unidade_operacao: "", 
                id_centro_custo: "", 
                id_contato_status: "", 
                id_equipamento: "", 
            },
            dados: [],
            edicao: null, 
            validate: false,
            breadcrumb: null,
            lista_todos_status: [], 
            lista_status: [], 
            lista_tarefa_grupos: [],
            prioridades: [],
            status_pronto: null
        };
    },

    components: { 
        AzInput, 
        AzSubmit, 
        AzPeriodo, 
        AzEmptyState,
        AzAuditLogButton, 
        CelulaDadosPaciente,
        RegistrarContatos, 
        AnexarMarcacaoDocumentos,
        Formulario,
        AzSubTitle, 
        PrintExport, 
        CabecalhoGenerico, 
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            if ( !this.filtro.search ) 
                return this.dados;

            let reg = this.$util.getregex(this.filtro.search);

            return this.dados.filter(item => !this.filtro.search || reg.test(JSON.stringify(item)) );
        },

        lista_grupos_atend: function () { 
            if ( !this.lista_tarefa_grupos )
                return [];

            return this.lista_tarefa_grupos.filter(item => item.check_acesso);
        }, 

        dados_exportacao: function () { 
            return this.lista.map(tarefa => { 
                return { 
                    id_tarefa: tarefa.id_tarefa, 
                    grupo: ( tarefa.servico && tarefa.servico.grupo ) ? tarefa.servico.grupo.st_nome : "",
                    servico: tarefa.servico ? tarefa.servico.st_nome : "",
                    responsavel: tarefa.usuario ? ( tarefa.usuario.pessoa ? tarefa.usuario.pessoa.st_nome : tarefa.usuario.st_login ) : '', 
                    criador: tarefa.criador.pessoa ? tarefa.criador.pessoa.st_nome : tarefa.criador.st_login, 
                    status: ( tarefa.contato && tarefa.contato.contato_status ) ? tarefa.contato.contato_status.st_contato_status : '', 
                    descricao: tarefa.st_descricao,
                    unidade: ( tarefa.centro && tarefa.centro.unidade_operacao ) ? tarefa.centro.unidade_operacao.st_sigla : '',
                    centro_custo: tarefa.centro ? tarefa.centro.st_nome : '', 
                    data_criacao: this.$util.getFormatDate(tarefa.created_at), 
                    data_prazo: tarefa.dt_prazo ? this.$util.getFormatDate(tarefa.dt_prazo) : '', 
                    data_execucao: ( tarefa.dt_execucao && tarefa.fl_feita ) ? this.$util.getFormatDate(tarefa.dt_execucao) : '', 
                    feita: tarefa.fl_feita ? 'Sim' : 'Não',
                    recurso: tarefa.equipamento ? tarefa.equipamento.search : '', 
                }
            });
        }

    },

    methods: { 
        abrir_pep(paciente) { 
            $('.modal').modal('hide');
            this.$root.perfil(paciente);
        },

        visualizar_laudo (laudo) { 
            const params = {
                id: laudo.id_laudo,
                fila: 'vt', // this.filtro.id_fila_laudo,
                lista: [], // lista,
                filtro: null, // this.filtro,
            };

            this.$router.push({
                name: 'laudo',
                params: params,
            });
        },

        selecao_formulario () { 
            if ( this.edicao.id_tarefa )
                return;

            if ( !this.edicao.id_tarefa_grupo_servico ) { 
                this.edicao.js_outros_campos = null;
                return;
            }

            let servico = this.lista_tarefa_grupos.flatMap(item => item.servicos)
                .find(item => item.id_tarefa_grupo_servico == this.edicao.id_tarefa_grupo_servico);

            if ( servico && servico.js_formulario && servico.js_formulario.length ) { 
                this.edicao.js_outros_campos = _.cloneDeep(servico.js_formulario);
            } else { 
                this.edicao.js_outros_campos = null;
            }
        },

        lista_servicos (id_tarefa_grupo) { 
            if ( !this.lista_tarefa_grupos )
                return [];

            let grupo = this.lista_tarefa_grupos.find(item => item.id_tarefa_grupo == id_tarefa_grupo);

            return grupo ? grupo.servicos : [];
        },

        abrir_contatos (item) { 
            this.edicao = _.cloneDeep(item);

            this.edicao.model = { 
                type: 'tarefa',
                id: this.edicao.id_tarefa, 
            };

            this.edicao.nome_paciente = this.edicao.paciente ? this.edicao.paciente.st_nome : null;

            this.$refs.regcontatos.editar(this.edicao);
        },

        remover () { 
            let info = _.cloneDeep(this.edicao);

            info.fl_ativo = false;
        
            this.$util.atualizar(this, { 
                service: 'tarefas',
                dados: info,
                toast: true, 
                reload: true, 
                modal: 'tarefaModal', 
            });
        },

        atualizar_execucao (tarefa) { 
            let info = _.cloneDeep(tarefa);

            info.fl_feita = !tarefa.fl_feita;
            
            info.executar = true 

            if (info.fl_feita && this.status_pronto) {
                const status_tarefa = this.get_infos_contato_status(tarefa);

                if ( status_tarefa ) { 
                
                    this.$util.atualizar(this, { 
                        service: 'crm',
                        func: 'save_contato',
                        dados: {
                            ...status_tarefa,
                        }
                    });

                }
            }

            this.$util.atualizar(this, { 
                service: 'tarefas',
                dados: info,
                toast: true, 
            });
        },

        editar (tarefa) { 
            this.edicao = _.cloneDeep(tarefa);
            
            this.validate = false;

            $('.modal').modal('hide');
            $('#tarefaModal').modal('show');
        },

        load() {
            this.$util.load(this, { 
                service: 'tarefas',
                parms: { 
                    id_usuario: this.$store.state.user.id_usuario, 
                    ...this.filtro, 
                    lista: true, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
            this.$util.load(this, { 
                service:'tarefa_prioridade',
                func: 'index',
                parms: { 
                    ativos: true,
                },
                loadTo: res => { 
                    this.prioridades = res;
                }
            });
            this.$util.loadItem(this, { 
                service: 'tarefa_grupos',
                func: 'index',
                parms: { 
                    lista: true, 
                }
            })
            .then(res => { 
                this.lista_tarefa_grupos = res;
            });
            this.$util.load(this, { 
                service: 'contato_status',
                func: 'index',
                parms: { 
                    lista: true,
                    model: 'tarefa',
                    ativos: true, 
                },
                loadTo: res => { 
                    this.lista_todos_status = res;
                    this.lista_status = res;
                    this.status_pronto = this.lista_status
                        .filter((ls) => ls.js_configs ? ls.js_configs.fl_pronta : false);
                    this.status_pronto = Object.assign({}, ...this.status_pronto);
                    if (this.status_pronto) {
                        this.lista_status = this.lista_status.filter((ls) => ls.js_configs ? !ls.js_configs.fl_pronta : true)
                    }
                }
            });
        },

        loadContato(status) {
            let ls_status = this.lista_todos_status.filter((ls) => ls.id_contato_status == status.id_contato_status);
            ls_status = Object.assign({}, ...ls_status);
            
            if ( ls_status && ls_status.js_configs.fl_pronta ) {
                let tarefa_alter = this.dados.filter((dado) => dado.id_tarefa == status.model_id);
                
                if ( !tarefa_alter ) {
                    this.load();
                    return;
                }

                tarefa_alter = Object.assign({}, ...tarefa_alter);
                tarefa_alter.fl_feita = true;

                this.$util.atualizar(this, { 
                    service: 'tarefas',
                    dados: tarefa_alter,
                    modal: 'tarefaModal',
                    toast: true, 
                    reload: true, 
                    callback: () => {
                        this.load();
                    }
                });
            }
        },

        atualizar() { 
            this.edicao.id_usuario = this.edicao.usuario ? this.edicao.usuario.id_usuario : null; 
            this.edicao.id_paciente = this.edicao.paciente ? this.edicao.paciente.id_pessoa : null; 
            this.edicao.id_equipamento = this.edicao.equipamento ? this.edicao.equipamento.id_equipamento : null;
            this.edicao.grupo_selec = this.filtro.grupo ? true : false;
            
            this.$util.atualizar(this, { 
                service: 'tarefas',
                dados: this.edicao,
                modal: 'tarefaModal',
                toast: true, 
                reload: true, 
            });
        },

        incluir() { 
            this.validate = false;

            let id_uo = this.$util.unidade_operacao()
                ? this.$util.unidade_operacao().id_unidade_operacao
                : '';

            if ( id_uo ) { 
                console.log('id_uo', id_uo, this.$util.centros_usuario(id_uo, true));
            }
            
            let id_cc = ( id_uo && this.$util.centros_usuario(id_uo, true).length == 1 ) 
                ? this.$util.centros_usuario(id_uo, true).id_centro_custo
                : '';

            this.edicao = { 
                id_tarefa: null, 
                st_descricao: "", 
                id_usuario: "", 
                fl_ativo: true,
                fl_feita: false, 
                para_paciente: false, 
                para_outro: false, 
                destino: 'M', 
                id_tarefa_grupo_servico: null, 
                paciente: "", 
                usuario: "", 
                id_unidade_operacao: id_uo,
                id_centro_custo: id_cc
            };

            $('.modal').modal('hide');
            $('#tarefaModal').modal('show');
        },

        get_infos_contato_status(tarefa) {
            if ( !this.status_pronto || !this.status_pronto.id_contato_status ) { 
                return;
            }
            
            return {
                id_contato_status: this.status_pronto.id_contato_status,
                id_usuario: this.$store.state.user.id_usuario,
                model_type: "tarefa",
                model_id: tarefa.id_tarefa,
                st_observacoes: "TAREFA PRONTA (CHECKED)"
            }
        }
    },

    mounted() { 
        this.load();

        let bc = this.$store.state.breadcrumb;

        if ( bc.length > 0 && !bc.find(item => item.name == 'Tarefas') ) { 

            bc.push({ name: 'Tarefas', path: "/tarefas" });
            this.$store.commit('setBreadcrumb', bc);

        } else { 

            this.breadcrumb = [
                { name: "Tarefas", path: "/tarefas"},
            ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

        }
    }
}
</script>